<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<GBModalVScrollable class="member-info"
			title="メンバー情報"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header v-if="!isModeReference">
				<div class="modal-header-member-info">
					<v-btn flat blue large color="white" v-on:click.stop="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClickDelete" :disabled="isMyself">削除</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-layout wrap mx-2 pr-2>
					<v-flex xs2 mt-3 v-bind:class="classNameLabel">
						名前
					</v-flex>
					<v-flex xs10 mt-3 class="content-name">
						<template  v-if="isModeReference">
							{{ value.member.name }}
						</template>
						<template v-else>
							<v-text-field
								v-model="value.member.name"
								maxlength="40"
								:rules="[rules.required, rules.length_name]"
								counter
							></v-text-field>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="label">
						連絡先
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<template  v-if="isModeReference">
							{{ value.member.tel }}
						</template>
						<template v-else>
							<v-text-field
								v-model="value.member.tel"
								maxlength="20"
								:rules="[rules.validate, rules.length_tel]"
								counter
							></v-text-field>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="multi-line-label" v-if="!isWorker">
						分類
					</v-flex>
					<v-flex xs10 mt-3 class="content" v-if="!isWorker">
						<GBClasses
							:items="selectedClasses"
							:max_width="maxWidth"
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-if="!isModeReference"
							v-on:click="onClickShowClassSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
					<v-flex xs2 mt-3 class="multi-line-label" v-if="!isWorker">
						色
					</v-flex>
					<v-flex xs10 mt-3 class="content" v-if="!isWorker">
						<GBColors
							:items="selectedColor"
							:max_width="maxWidth"
							:all_show=false
							:type="typeColor"
							:select_type="typeSelect.SINGLE"
						/>
						<v-btn
							flat
							fab
							class="btn-add-color"
							v-if="!isModeReference"
							v-on:click="onClickShowColorSelect"
						>
							<v-icon>color_lens</v-icon>
						</v-btn>
					</v-flex>
					<v-flex xs2 mt-3 d-flex align-start class="multi-line-label" v-if="!isWorker">
						備考
					</v-flex>
					<v-flex xs10 mt-3 class="content row-group-remarks" v-if="!isWorker">
						<template  v-if="isModeReference">
							<nl2br tag="p" :text="value.member.remarks" />
						</template>
						<template v-else>
							<v-textarea
								v-model="value.member.remarks"
								outline
								maxlength="100"
								:rules="[rules.length_remarks]"
								counter
							></v-textarea>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="label">
						ID
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<template v-if="!isModeEntry">
							{{ value.member.login_id }}
						</template>
						<template v-else>
							<v-text-field
								v-model="value.member.login_id"
								maxlength="20"
								:rules="[rules.required, rules.validate, rules.length]"
								counter
							></v-text-field>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="label">
						pass
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<template  v-if="isModeReference">
							{{ maskPassword }}
						</template>
						<template v-else>
							<v-text-field
								v-if="isModeEntry || isMyself"
								v-model="value.member.login_password"
								:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
								:type="show_passwd ? 'text' : 'password'"
								@click:append="show_passwd = !show_passwd"
								maxlength="20"
								counter
								:rules="[rules.required, rules.validate, rules.length]"
							></v-text-field>
							<v-text-field
								v-else
								v-model="value.member.login_password"
								:append-icon="voidFlag ? 'block' : 'check_circle_outline'"
								:type="'password'"
								@click:append="onClickVoid"
								readonly
							></v-text-field>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="label" v-if="!isWorker">
						権限
					</v-flex>
					<v-flex xs10 mt-3 class="content" v-if="!isWorker">
						<template  v-if="isModeReference">
							{{ selectedPermission }}
						</template>
						<template v-else>
							<v-select
								:value="memberPermission"
								:items="permission_roles"
								:disabled="!canChangePermission"
								@input="onSelectePermission"
								item-text="text"
								item-value="id"
								label="Select"
								return-object
								single-line
							></v-select>
						</template>
					</v-flex>
				</v-layout>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import clonedeep from 'lodash/cloneDeep';
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBClasses from './GBClasses';
import GBColors from './GBColors';
import Color from '../data/Color';
import GBDialog from './GBDialog';
import {PERMISSION, FORM_MODE, VOID_FLAG, COLOR_SELECT_TYPE} from '../data/Const';
import Util from '../classes/Util';
import Notification from '../classes/Notification';

const MASK_WORD = "･";

const validateLength = function(value) {
	if(value.length >= 6 && 20 >= value.length)
		return true;
	return false;
};

const validateLengthName = function(value) {
	if(value.length <= 40)
		return true;
	return false;
};

const validateLengthTel = function(value) {
	if(value.length <= 20)
		return true;
	return false;
};

const validateLengthRemarks = function(value) {
	if(value.length <= 100)
		return true;
	return false;
};

export default {
	name: 'GBRightPaneMemberInfo',
	props: [
		"value",
		"selected_class",
		"selected_color",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBClasses,
		GBColors,
		GBDialog,
	},
	data: function() {
		return {
			rules: {
				required: v => !!v || '入力してください',
				validate: v => (!v) ? true : Util.isValidCharPassword(v) || '無効な文字が含まれています',
				length: v => validateLength(v) || '6文字以上20文字以下で入力してください',
				length_name: v => validateLengthName(v) || '40文字以内で入力してください',
				length_tel: v => validateLengthTel(v) || '20文字以内で入力してください',
				length_remarks: v => validateLengthRemarks(v) || '100文字以内で入力してください',
			},
			permission_roles: [
				{ id: PERMISSION.ROLE.WORKER, text: 'WORKER'},
				{ id: PERMISSION.ROLE.VIEWER, text: 'VIEWER'},
				{ id: PERMISSION.ROLE.ADMIN, text: 'ADMIN'},
				{ id: PERMISSION.ROLE.ADMIN_WORKER, text: 'ADMIN & WORKER'}
			],
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			show_passwd: false,
			typeSelect: COLOR_SELECT_TYPE,
		};
	},
	methods: {
		onClose: function() {
			this.show_passwd = false;
			this.$emit('close');
		},
		onClickDone: function() {
			if(this.selected_class)
				this.value.member.classes = this.selected_class;
			if(this.selected_color)
				this.value.member.color_code = this.selected_color[0].code;

			//error
			if(!this.value.member.name || !this.value.member.login_id || !this.value.member.login_password){
				this.errorDialog('未入力の項目があります');
				return;
			}else if(!Util.isValidCharPassword(this.value.member.login_id)
					|| !Util.isValidCharPassword(this.value.member.login_password)
					|| !((!this.value.member.tel) ? true : Util.isValidCharPassword(this.value.member.tel))) {
				this.errorDialog('入力値が無効です');
				return;
			}else if(!validateLength(this.value.member.login_id) || !validateLength(this.value.member.login_password)) {
				this.errorDialog('ID, パスワードは6文字以上20文字以下で入力してください');
				return;
			}else if(!validateLengthTel(this.value.member.tel)){
				this.errorDialog('連絡先は20文字以内で入力してください');
				return;
			}else if(!validateLengthName(this.value.member.name)){
				this.errorDialog('名前は40文字以内で入力してください');
				return;
			}else if(!validateLengthRemarks(this.value.member.remarks)){
				this.errorDialog('備考は100文字以内で入力してください');
				return;
			}

			if (((this.value.member.permission & PERMISSION.TYPE.ADMIN) == 0) && !this.isOtheroneHasAdmin()) {
				this.errorDialog('管理権限を持つメンバーが一人もいません。');
				return;
			}

			//confirmation
			let m = this.$store.getters.mstMemberData(this.value.member.code);
			if (m === null) {
				this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
				this.onClose();
				return;
			}
			if(m.void !== this.value.member.void && this.value.member.void == VOID_FLAG.VOID){
				const agree = () => {
					this.dialog.display = false;
					this.value.member.is_updated = true;
					this.$store.dispatch('updateDataMember', this.value.member).then((res) => {
						if (res)
							this.$emit('update-dataset');
						else
							this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
					});
					this.dialog.agree = null;
					this.onClose();
				};
				this.confirmationDialog('メンバーのパスワードが無効となりますが、よろしいでしょうか', agree);
				return;
			}

			this.value.member.is_updated = true;
			this.$store.dispatch('updateDataMember', this.value.member).then((res) => {
				if (res)
					this.$emit('update-dataset');
				else
					this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
			});
			this.onClose();
		},
		onClickDelete: function() {
			const agree = () => {
				this.dialog.display = false;
				this.$store.dispatch('deleteDataMember', {
					member_code: this.value.member.code,
				}).then((res) => {
					if (res) {
						this.$emit('update-dataset');
					} else {
						this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
					}
				});
				this.dialog.agree = null;
				this.onClose();
			};
			this.confirmationDialog('メンバーを削除しますが、よろしいでしょうか', agree);
		},
		onClickShowClassSelect: function() {
			this.$emit('show-class-select', clonedeep(this.selectedClasses));
		},
		onClickShowColorSelect: function() {
			this.$emit('show-color-select', {
				color: clonedeep(this.selectedColor),
				type: this.typeColor,
				select_type: this.typeSelect.SINGLE,
			});
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		confirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		isOtheroneHasAdmin: function() {
			return this.$store.getters.adminMember.filter((m) => {
				if (m.code == this.value.member.code)
					return false;
				return true;
			}).length > 0;
		},
		onClickVoid: function() {
			if (!this.value) return;
			this.value.member.void = this.voidFlag ? VOID_FLAG.VALID : VOID_FLAG.VOID;
		},
		onSelectePermission: function(value) {
			if (this.value)
				this.value.member.permission = value.id;
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		isModeReference: function() {
			if(!this.value)
				return true;
			return this.value.mode == FORM_MODE.REFERENCE;
		},
		isModeEntry: function() {
			if(!this.value)
				return false;
			return this.value.mode == FORM_MODE.ENTRY;
		},
		selectedClasses: function() {
			if(this.selected_class)
				return this.selected_class;
			else
				return this.value.member.classes;
		},
		selectedColor: function() {
			if(this.selected_color) {
				return this.selected_color;
			} else {
				return [{ code: this.value.member.color_code }];
			}
		},
		maskPassword: function() {
			let mask_password = "";
			let strLen = this.value.member.login_password.length;
			for (let i = 0; i < strLen; i++) {
				mask_password += MASK_WORD;
			}
			return mask_password;
		},
		isMyself: function() {
			if (!this.value)
				return false;

			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return false;

			return this.value.member.code == access_token.sub;
		},
		canChangePermission: function() {
			return this.$store.getters.isAdmin;
		},
		selectedPermission: function() {
			if (!this.value)
				return null;
			let p = this.permission_roles.filter(p =>{ return p.id == this.value.member.permission })[0];
			if (!p) return null;
			return p.text;
		},
		voidFlag: function() {
			return this.value.member.void == VOID_FLAG.VOID
		},
		isWorker: function() {
			return this.$store.getters.isWorkerRole;
		},
		memberPermission: function() {
			if (this.value) {
				let found = this.permission_roles.filter((r) => {
					return r.id == this.value.member.permission;
				})[0];
				if (found)
					return found;
			}

			return null;
		},
		classNameLabel: function() {
			if(this.isModeReference)
				return ['multi-line-label'];
			else
				return ['label'];
		},
		maxWidth: function() {
			let max_width = 224;
			if (this.isModeReference)
				max_width = 264;
			return max_width;
		},
		typeColor: function() {
			return Color.RELATION_TYPE.MEMBER;
		},
	},
	watch: {
		'value': function() {
			// 複数のv-dialogを表示後、フォーカスを当てるなどすると無限再帰エラーが発生
			// バグレポート ⇒ https://github.com/vuetifyjs/vuetify/issues/8459
			if (this.value !== undefined && this.value !== null)
				if (this.isModeEntry)
					this.$nextTick(() => {
						setTimeout(() => {
							this.$parent.$parent.$parent.$el.querySelector('.member-info .content-name input').select();
						}, 10);
					});
		},
	},
}
</script>
<style>
	.modal-window.member-info .row-group-remarks {
		min-height: 150px;
	}
	.modal-window.member-info .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.member-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.member-info .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.member-info .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.modal-window.member-info .modal-header-member-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.member-info .btn-add-class, .modal-window.member-info .btn-add-color {
		height: 24px;
		width: 24px;
		margin-top: 0px;
	}
</style>
